const Star = ({ size, color }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.38525L14.5281 9.47691H22.7056L16.0898 14.4782L18.6178 22.572L12 17.5707L5.38216 22.572L7.91023 14.4782L1.29443 9.47691H9.47193L12 1.38525Z"
        fill={color}
        stroke="black"
        strokeWidth="1.06492"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Star;
